import * as types from "./mutation_types";

export default {
  [types.FORMATION_RESET](state) {
    Object.assign(state, {
      error: "",
      isLoading: false,
      items: null,
    });
  },

  [types.FORMATION_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.FORMATION_SET_ITEMS](state, items) {
    Object.assign(state, { items });
  },

  [types.FORMATION_TOGGLE_LOADING](state) {
    Object.assign(state, { isLoading: !state.isLoading });
  },
};
